export default {
    URL: {
        self: 'https://console.bce.baidu.com/tms/#/tms/create/self?pageResource=aiqichaLand',
        auxiliary: 'https://console.bce.baidu.com/tms/#/tms/create/assistance?type=AUXILIARY_REGISTRATION&pageResource=aiqichaLand',
        guarantee: 'https://console.bce.baidu.com/tms/#/tms/create/assistance?type=GUARANTEE_REGISTRATION&pageResource=aiqichaLand'
    },
    /* eslint-disable */
    productData: [
        {type: 'zero', money: '', price: '1199元', originPrice: '1499元/次', packageId: '904c46a4-db3b-48cc-b5a7-ae176dfcc6df', periodId: '181e1909-1eaf-483a-92a4-17a9694d3f43'},
        {type: 'small', money: 'small', price: '1199元', originPrice: '1399元/次', packageId: 'd9cad80e-1804-4295-85f0-11010fece6fe', periodId: 'f73527e6-1228-40e2-9183-4b89623f075a'},
        {type: 'small', money: 'normal', price: '1499元', originPrice: '1699元/次', packageId: '54e3b5aa-c27a-4ed7-91cf-900be9fe264f', periodId: '1b243480-d8dc-4e6e-8994-9819c99b63fa'},
        {type: 'small', money: 'large', price: '1799元', originPrice: '2099元/次', packageId: '5811bd85-eb2c-44fd-abe6-6626aaba9cb6', periodId: 'e41f9e6e-6955-479b-b7b3-d2e92c00df4c'},
        {type: 'normal', money: 'small', price: '2599元', originPrice: '3499元/次', packageId: '112830ef-5738-4bea-b726-2459a5fe83f6', periodId: 'c069ca82-407a-4321-a0a4-5ba0de9e6501'},
        {type: 'normal', money: 'normal', price: '3499元', originPrice: '4099元/次', packageId: '3c1504a0-4b23-4b3c-ae93-eae1e17f9209', periodId: 'e5ccbc74-e375-462f-847a-c427ba01a466'},
        {type: 'normal', money: 'large', price: '4199元', originPrice: '4899元/次', packageId: 'd6f2a1cf-1d41-4d11-9a3e-b6ff82232606', periodId: '336fe3c8-091f-4e82-94bf-3a8886f9e417'}
    ],
    /* eslint-enable */
    AREA: [
        {text: '北京', value: 'BEIJING'},
        {text: '广东', value: 'GUANGDONG'},
        {text: '浙江', value: 'ZHEJIANG'},
        {text: '江苏', value: 'JIANGSU'},
        {text: '上海', value: 'SHANGHAI'},
        {text: '四川', value: 'SICHUAN'},
        {text: '河南', value: 'HENAN'},
        {text: '福建', value: 'FUJIAN'},
        {text: '河北', value: 'HEBEI'},
        {text: '辽宁', value: 'LIAONING'},
        {text: '山东', value: 'SHANDONG'},
        {text: '湖北', value: 'HUBEI'},
        {text: '海南', value: 'HAINAN'},
        {text: '吉林', value: 'JILIN'},
        {text: '安徽', value: 'ANHUI'},
        {text: '湖南', value: 'HUNAN'},
        {text: '黑龙江', value: 'HEILONGJIANG'},
        {text: '重庆', value: 'CHONGQING'},
        {text: '陕西', value: 'SHANXI_SHAN'},
        {text: '江西', value: 'JIANGXI'},
        {text: '广西', value: 'GUANGXI'},
        {text: '天津', value: 'TIANJIN'},
        {text: '内蒙古', value: 'NEIMENGGU'},
        {text: '云南', value: 'YUNNAN'},
        {text: '贵州', value: 'GUIZHOU'},
        {text: '新疆', value: 'XINJIANG'},
        {text: '山西', value: 'SHANXI_JIN'},
        {text: '甘肃', value: 'GANSU'},
        {text: '宁夏', value: 'NINGXIA'},
        {text: '西藏', value: 'XIZANG'},
        {text: '青海', value: 'QINGHAI'},
        {text: '外资', value: 'WAIZI'}
    ]
};